import {Avatar, IconButton, Tooltip} from "@mui/material";
import {ContentPaste} from "@mui/icons-material";
import * as React from "react";
import useDrive from "../../hooks/useDrive";
import {ACTIONS} from "../DriveRow/driveRowConst";
import FileService from "../../services/FileService";
import DriveService from "../../services/DriveService";
import useNotification from "../../hooks/useNotification";
import {DRIVE_TYPES, UPLOAD_STATUS} from "../../config/appConst";

export default function FileAndFolderCopy() {

    const {copyPath, setCopyPath, CurrentDrive, changeCurrentDrive, changeUploadStatus} = useDrive();
    const {addNotification} = useNotification();
    let title;
    let notiType = "success";
    const past = async () => {
        const {type, sourceDrive} = copyPath;
        if(sourceDrive !== CurrentDrive.driveType) {
            // console.log("file-cp", sourceDrive, CurrentDrive.driveType)
            addNotification({type: "error", message: "You can't do this file operation"});
            return false;
        }
        switch (type) {
            case ACTIONS.FILE_COPY:
                changeUploadStatus(UPLOAD_STATUS.FILE_COPPING);
                title = "File copied successful";
                await fileCpMv({...copyPath, move: 0});
                break;
            case ACTIONS.FILE_MOVE:
                changeUploadStatus(UPLOAD_STATUS.FILE_MOVING);
                title = "File moved successful";
                await fileCpMv({...copyPath, move: 1});
                break
            case ACTIONS.FOLDER_COPY:
                changeUploadStatus(UPLOAD_STATUS.FOLDER_COPPING);
                title = "Folder copied successful";
                await folderCpMv({...copyPath, move: 0});
                break;
            case ACTIONS.FOLDER_MOVE:
                changeUploadStatus(UPLOAD_STATUS.FOLDER_MOVING);
                title = "Folder moved successful";
                await folderCpMv({...copyPath, move: 1});
                break
        }
        addNotification({type: notiType, message: title});
        changeUploadStatus(UPLOAD_STATUS.DONE);
        const drive = await DriveService.getFileTree(CurrentDrive.parent, CurrentDrive.driveType);
        if (CurrentDrive.driveType === DRIVE_TYPES.SHARED) {
            changeCurrentDrive({...CurrentDrive, drive: {}, sharedDrive: drive});
        } else {
            changeCurrentDrive({...CurrentDrive, drive, sharedDrive: {}});
        }

        setCopyPath({});
    }

    const fileCpMv = async ({path, name, move}) => {
        const file_name = path + "/" + name;
        const file_name_new = CurrentDrive.parent + "/" + name;
        await FileService.copy({file_name, file_name_new, move, driveType: CurrentDrive.driveType});
        setCopyPath({});

    }
    const folderCpMv = async ({path, name, move}) => {
        const folder = path + "/" + name;
        const folder_new = CurrentDrive.parent;
        await DriveService.copy({folder, folder_new, move, driveType: CurrentDrive.driveType});
        setCopyPath({});

    }
    return copyPath && copyPath.name ?
        <Avatar variant={"rounded"} style={{width: "45px", height: "45px", backgroundColor: "#8c3b61"}} onClick={past}>
        <Tooltip title="Past here">
            <IconButton color={"inherit"}>
                <ContentPaste/>
            </IconButton>
        </Tooltip>
    </Avatar> : ''
}